import Timeline from './Timeline';
import './style.scss';

export default Timeline;
